<template>
  <v-container fluid fill-height class="pa-0 ma-0 white" id="profile">
    <v-layout column class="pa-0 ma-0">
      <v-card-text>
        <h2 style="margin: 0% auto;"><b>Kontrak</b></h2>
      </v-card-text>

      <v-container grid-list-xl fluid>
        <v-layout row wrap>
        
          <!-- mini statistic start -->

          <v-flex lg6 sm6 xs12>
            <mini-statistic
              head="Kontrak Terdaftar"
              icon="fas fa-file-contract"
              title="22"
              sub-title="Rupiah"
              color="light-green"      
            >
            </mini-statistic>            
          </v-flex>   

          <v-flex lg6 sm6 xs12>
            <mini-statistic
              head="Perusahaan Terhubung"
              icon="fas fa-handshake"
              title="8"
              color="light-blue"      
            >
            </mini-statistic>            
          </v-flex>   

          <v-flex lg6 sm6 xs12>
            <mini-statistic
              head="Pengiriman Hari ini"
              icon="fas fa-clock"
              title="7"
              sub-title="Komoditi"
              color="deep-orange"      
            >
            </mini-statistic>  
          </v-flex>

          <v-flex lg6 sm6 xs12>
            <mini-statistic
              head="Volume Penjualan"
              icon="fas fa-box-open"
              title="2680 Kg"
              sub-title="Kg"
              color="purple"      
            >
            </mini-statistic>             
          </v-flex>   
                            
          <!-- mini statistic end -->   

          <!-- medium statistic start -->   

          <v-flex lg12 sm12 xs12>
            <v-widget title="Komoditas (Kg)">
              <div slot="widget-content">
                  <e-chart 
                  :path-option="[
                    ['dataset.source', dataset.campaign],
                    ['color', [color.amber.base, color.indigo.base, color.pink.base, color.red.base, color.teal.base, color.purple.base, color.lightBlue.base, color.green.lighten1]],
                    ['legend.orient', 'horizontal'],
                    ['legend.y', 'bottom'],
                    ['xAxis.show', false],
                    ['yAxis.show', false],          
                    ['series[0].type', 'pie'],         
                    ['series[0].avoidLabelOverlap', true],         
                    ['series[0].radius', ['50%', '70%']],         
                  ]"
                  height="350px"
                  width="100%"
                  >
                  </e-chart>   
              </div>
            </v-widget>            
          </v-flex>

          <v-flex lg12 sm12 xs12>
            <v-widget title="Kapasitas Pedagang Perantara (Kg)" content-bg="white">
              <div slot="widget-content">
                <e-chart
                  :path-option="[
                    ['dataset.source', siteTrafficData],
                    ['color', [color.lightBlue.base]],
                    ['legend.show', true],
                    ['xAxis.axisLabel.show', true],
                    ['yAxis.axisLabel.show', true],
                    ['grid.left', '2%'],
                    ['grid.bottom', '5%'],
                    ['grid.right', '3%'],
                    ['series[0].type', 'bar'],
                    ['series[0].areaStyle', {}],
                    ['series[0].smooth', true],
                  ]"
                  height="400px"
                  width="100%"
                >
                </e-chart>
              </div>
            </v-widget>
          </v-flex>

          <v-flex lg12 sm12 xs12>
            <box-chart
              title="Harga Jual (Rp)"
              icon="trending_up"
              :data="dataset.pemasukan"
              :chart-color="[color.red.lighten1]"
              type="area"
            >
            </box-chart>
          </v-flex>        

          <!-- medium statistic end -->   

        </v-layout>
      </v-container>

      <v-card-text class="pa-0 margin-title">
        
        <v-card v-if="kontrakID">
          <kontrak-list></kontrak-list>
        </v-card>

        <v-card v-else>
          <kontrak-list-two></kontrak-list-two>
        </v-card>

      </v-card-text>

    </v-layout>
  </v-container>     
</template>

<script>
import API from "@/api"
import { getUserById } from '@/api/user';
import { monthVisitData2, pemasukanData2, campaignData2 } from '@/api/chart';

import EChart from '@/components/chart/echart';
import MiniChart from '@/components/widgets/chart/MiniChart';
import BoxChart from '@/components/widgets/chart/BoxChart';
import MiniStatistic from '@/components/widgets/statistic/MiniStatistic';
import Material from 'vuetify/es5/util/colors';
import VWidget from '@/components/VWidget';

import KontrakList from '@/components/kontrak/KontrakList'
import KontrakListTwo from '@/components/kontrak/KontrakListTwo'
import TambahkanKontrak from '@/components/kontrak/TambahkanKontrak'
export default {
  components: {
    VWidget,
    MiniStatistic,
    EChart,
    BoxChart,
    MiniChart,
    KontrakList,
    KontrakListTwo,
    TambahkanKontrak,
  },
  data () {
    return {
      chat: null,
      selectedTab: null,
      status: false,
      dataset: {
        monthVisit: monthVisitData2,
        pemasukan: pemasukanData2,
        campaign: campaignData2,
      },
      color: Material,
      kontrakID: localStorage.kontrakID
    };
  },
  computed: {
   
    user () {
      let Origin = {
        name: 'Kontrak',
        avatar: '',
      };
      let user = getUserById(this.$route.params.uuid);
      return Object.assign(Origin, user);
    },    

    siteTrafficData () {
      return API.getMonthVisit2;
    },

  },
};
</script>